// extracted by mini-css-extract-plugin
export var formInfo = "fs_Mg";
export var formInfo__image = "fs_L9";
export var formInfo__link = "fs_Mf";
export var formInfo__list = "fs_Mc";
export var formInfo__sectionHr = "fs_Md";
export var formInfo__services = "fs_L8";
export var formInfo__title = "fs_Mb";